import styled from "styled-components";

export const StyledContentCollaboratorChip = styled.div<{
  $isDraggable?: boolean;
  $isCalibration?: boolean;
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  cursor: ${(props) => (props.$isDraggable ? "grab" : "default")};
  padding-right: ${(props) => (props.$isCalibration ? "0px" : "4px")};

  & .left-content {
    display: flex;
    gap: 6px;
    align-items: center;
    min-width: 0;
    flex: 1;
  }

  & .icon-slot {
    flex-shrink: 0;
  }

  & .percentage-container {
    display: flex;
    height: 18px;
    align-items: center;
    border-radius: 100px;
    flex-shrink: 0;
    text-align: center;
    padding: 0 6px;
  }
`;

export const StyledNameCollaboratorChip = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;
